// date
export const DATE_FORMAT = 'MM/DD/YYYY'
export const DATE_FORMAT_FOR_SERVER = 'YYYY-MM-DD'
export const SHORT_DATE_FORMAT = 'M/D/YYYY'
export const FILTER_MONTH_FORMAT = 'MMMM YYYY'
export const DAY_MONTH = 'MM/DD'
export const PDF_DATE_FORMAT = 'MM/DD/YY'
export const TIME_FORMAT_FOR_SERVER = 'HH:mm:ss'
export const FREQUENCY_DATE_FORMAT = 'hh:mm A'
export const TIME_FORMAT = 'h:mm A'
export const CELL_TIME_FORMAT = 'h:mm:ss A'
export const US_TIME_FORMAT = 'h:mm a'
export const US_TIME_FORMAT_REPORT = 'hh:mm a'
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`
export const DATE_TIME_US_FORMAT_REPORT = `${DATE_FORMAT} ${US_TIME_FORMAT_REPORT}`
export const SHORT_DATE_TIME_FORMAT = `${SHORT_DATE_FORMAT} ${TIME_FORMAT}`
export const DATE_TIME_FORMAT_FOR_SERVER = `${DATE_FORMAT_FOR_SERVER} ${TIME_FORMAT_FOR_SERVER}`
export const MONTH_DAY = 'M/D'
export const YEAR_FORMAT = 'YYYY'
export const TIMEPICKER_MASK = '__:__ _M'
export const YEAR_AND_MONTH_FORMAT = 'YYYY-MM'
export const PRETTY_DATE_FORMAT = 'D MMM YYYY'

export const PASSWORD_REGEXP =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*()+\-<>]).{8,}$/

// Patient id regular expression
export const PATIENT_ID_REGEXP = /^[0-9]\d{6,9}$/

// Phone number regular expression
export const PHONE_NUMBER_REGEXP = /^\d{3}-\d{3}-\d{4}$/
// TODO antd normalize breaks PHONE_NUMBER_REGEXP validation
export const PHONE_NUMBER_REGEXP_NORMALIZED = /^\d{10}$/

// Email validation regular expression
// eslint-disable-next-line prefer-regex-literals
export const EMAIL_VALIDATION_REGEXP = new RegExp(
  '(?=(ˆ[a-z0-9_-]+\\.)*[a-z0-9_-]+@[a-z0-9_-]+(\\.[a-z0-9_-]+)*\\.[a-z]{2,10}$).{2,127}',
  'i'
)

export const IP_REGEX = /^(?:\d{1,3}|\*|X)(?:\.(?:\d{1,3}|\*|X)){3}$/

// Uuid regular expression
export const UUID_REGEXP =
  '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'
export const UUID_REGEXP_RULE =
  /[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}/i

// numbers
export const NUMBER_RANGE_REGEXP = /^\d{1,5}$/
export const NUMBER_WITH_ONE_DECIMAL = /^\d+\.?\d{1}?$/
export const NUMBER_WITH_DOT_RANGE_REGEXP = /^\d{1,5}\.?\d{0,2}?$/

// american time format regular expression
export const AMERICAN_TIME_FORMAT_REGEXP =
  /(^([0-1][0-9]|[2][0-3]):([0-5][0-9])(\s{0,1})([am|pm]{2,2})$)/i

// Blood pressure
export const BLOOD_PRESSURE_REGEXP = /^\d{1,3}\/\d{1,3}$/

// Duration
export const DURATION_PATTERN = /^[1-9]{1}\d{0,2}$/
export const DURATION_MASK_MINUTES_PATTERN = /^\d+$/

// NPI
export const NPI_PATTERN = /\b\d{10}\b/
export const NPI_MASK_INPUT = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/
]

// zip code
export const ZIP_CODE_PATTERN = /\b\d{5}\b/

// Thousand comma
export const THOUSAND_COMMA_REGEXP = /\B(?=(\d{3})+(?!\d))/g

// number diapasons validation rules
export const FROM_ZERO_TO_THIRTY = /^(|0|[1-9]|[0-2]\d|30{1,2})$/
export const FROM_ZERO_TO_FIFTY_NINE = /^([0-5]?\d)$/
export const FROM_ZERO_TO_NINE_HUNGRED_NINETY_NINE = /^(\d|[1-9]\d|[1-9]\d{2})$/
export const FROM_ONE_TO_TEN = /^(|[1-9]|10{1,2})$/
export const FROM_ONE_TO_TWENTY = /^(|[1-9]|[0-1]\d|20{1,2})$/
export const FROM_ONE_TO_YEAR = /^(?:36[0-5]|3[0-5]\d|[12]\d{2}|[1-9]\d?)$/
export const FROM_ONE_TO_NINETY_NINE = /^([1-9]|0[1-9]|[1-9]\d)$/
export const FROM_ONE_TO_HUNGRED = /^(\d{1,3}|100)$/
export const FROM_ONE_TO_THOUSAND = /^((\+|-|)[1-9][0-9]{0,2}|1000)$/
export const FOUR_DIGITS_MASK_WITH_DOT_REGEXP = /^\d{1,4}([.]{1}\d{1,2})?$/
export const SIX_DIGITS_REGEXP = /^(0|\d{1,6})$/

// fields parser
export const FIELD_INDEX = /(\[\d{1,}\])/

// latin letters with quotes
export const PATIENT_NAME_PATTERN = /^[\w\s\-'"]{2,}$/g

// Change password
export const CHANGE_PASSWORD_PATTERN = /^[1-9]{1}\d{0,2}$/

// Add/edit words
export const ADD_EDIT_PATTERN = /add|edit/gi

export const MASK_INPUT_PHONE = [
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/
]

export const MASK_PHONE = [
  /[1-9]/, // First digit (1-9)
  /[0-9]/, // Second digit (0-9)
  /[0-9]/, // Third digit (0-9)
  '-',
  /[0-9]/, // Fourth digit (0-9)
  /[0-9]/, // Fifth digit (0-9)
  /[0-9]/, // Sixth digit (0-9)
  '-',
  /[0-9]/, // Seventh digit (0-9)
  /[0-9]/, // Eighth digit (0-9)
  /[0-9]/, // Ninth digit (0-9)
  /[0-9]/ // Tenth digit (0-9)
]

export const TWO_DIGITS_MASK_INPUT = [/\d/, /\d/]
export const THREE_DIGITS_MASK_INPUT = [/\d/, /\d/, /\d/]
export const FOUR_DIGITS_MASK_INPUT = [/\d/, /\d/, /\d/, /\d/]
export const FOUR_DIGITS_MASK_WITH_DOT_INPUT = [
  /[\d.]/,
  /[\d.]/,
  /[\d.]/,
  /[\d.]/,
  /[\d.]/,
  /[\d.]/,
  /[\d.]/
]
export const FIVE_DIGITS_MASK_INPUT = [/\d/, /\d/, /\d/, /\d/, /\d/]
export const SIX_DIGITS_MASK_INPUT = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
export const DURATION_MASK_INPUT = [/\d/, /\d/, 'M', /\d/, /\d/, 'S']

export const PATIENT_ID_MASK_INPUT = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/
]

export const REFERRAL_ID_MASK_INPUT = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/
]

// time format regexp
export const US_TIME_FORMAT_REGEXP = /^(0?\d|1[0-2])(:[0-5]\d) [AP][M]$/gi

// text between two brackets
export const BETWEEN_TWO_BRACKETS = /\[(\d)\]/

export const ONLY_DIGITS_REGEXP = /[^+\d]/g

// Patient id regular expression
export const HTML_TAGS_REGEXP = /<\/?[^>]+(>|$)/g

// filename regexp
export const FILE_NAME_REGEXP = /.*filename=("|')?|("|')/gi

export const CARE_PLAN_GOALS_INTERVENTIONS_GAPS_REGEXP = /^((?!##\s+##).)*$/

export const URL_REGEXP_SIMPLE = /^(https?):\/\/.*$/
